import React from "react";

export interface ESignParticipantProgressCheckProps {
  sender: server.dto.ESignParticipantProgresses
  signer: server.dto.ESignParticipantProgresses
};

const ESignParticipantProgressElements = (props: ESignParticipantProgressCheckProps) => {
  return <div className="flex gap-small">
    <Check value={props.sender} isSigner={false} />
    <Check value={props.signer} isSigner={true} />
  </div>;
};

const Check = ({ value, isSigner }: { value: server.dto.ESignParticipantProgresses, isSigner: boolean }) => {
  return <div title={getTitle(value, isSigner)}>
    {Icon(value)}
  </div>;
};

const getTitle = (value: server.dto.ESignParticipantProgresses, isSigner: boolean) => {
  switch (value) {
    case "senderAutoSignActive":
      return isSigner ? RESX.ESign.SenderShouldSignFirst : RESX.ESign.SignerShouldSignFirst;
    case "automaticallyCompleted":
      return `${RESX.ESign.AutomaticallySigned} (${isSigner ? RESX.ESign.Signer : RESX.ESign.Sender})`;
    case "manuallyCompleted":
      return RESX.ESign.ManuallyCompleted;
    case "signedByPerson":
      return isSigner ? RESX.ESign.SignedBySigner : RESX.ESign.SignedBySender;
    case "readyForSigning":
      return `${RESX.ESign.PendingSignature} (${isSigner ? RESX.ESign.Signer : RESX.ESign.Sender})`;
    case "waitingForSigner":
      return RESX.ESign.WaitingForSigner;
  }
};

const Icon = (value: server.dto.ESignParticipantProgresses) => {
  switch (value) {
    case "senderAutoSignActive":
      return <i className="icon-hourglass gray"></i>;
    case "automaticallyCompleted":
      return <i className="icon-check darkgreen"></i>;
    case "manuallyCompleted":
      return <i className="icon-check purple"></i>;
    case "signedByPerson":
      return <i className="icon-check green"></i>;
    case "readyForSigning":
      return <i className="icon-check gray"></i>;
    case "waitingForSigner":
      return <i className="icon-hourglass gray"></i>;
  }
};

export default ESignParticipantProgressElements;